import React from 'react';
import Masthead from './components/Masthead.jsx';
import Search from './components/Search.js';
import Headstone from './components/Headstone.js';
import TheMap from './components/Map.js';
import InsetMap from './components/InsetMap.js';
import About from './components/About.js';
import ContactUs from './components/ContactUs.js';
import Legend from './components/Legend.jsx';
import Footer from './components/Footer.js';
import Welcome from './components/Welcome.jsx';
import Icons from './components/Icons.jsx';
import HillshadeToggle from './components/HillshadeToggle.js';

import './App.css';
import './AppLayout.css';

const App = (props) => {
  props.loadGravestones();

  const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

  return (
    <div className={(iOS) ? 'App ios' : 'App'}>
      <Welcome />
      <Masthead />
      {(props.aboutOpen) && (<About />)}
      {(props.contactUsOpen) && (<ContactUs />)}
      {(!props.aboutOpen && !props.contactUsOpen) && (
        <React.Fragment>
          <TheMap />
          <Legend />
          {(props.selectedGravestone) ? (
            <Headstone />
          ) : (
            <React.Fragment>
              <Search />
              <HillshadeToggle />
            </React.Fragment>
          )}
          {(props.showInset) && <InsetMap />}
        </React.Fragment>
      )}
      <Icons />
      <Footer />
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx